import { DateTimeService, WallClockDateService } from '@mews/framework';
import { FormValues } from '../types';

export const convertFormValuesToDateTimes = (values: FormValues, timezone: string) => {
    const { date, startTime, endTime } = values;

    if (date == null || startTime == null || endTime == null) {
        return undefined;
    }

    const timezonedDate = WallClockDateService.toTimezonedDate(date, timezone);
    const startDateTime = DateTimeService.fromDateAndTime(timezonedDate, startTime);
    const endDateTime = DateTimeService.fromDateAndTime(timezonedDate, endTime);

    return { startDateTime, endDateTime };
};
